module.exports = __webpack_public_path__ + "static/media/Solosis_gaussian2.0e2646af.png";